
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"icon-fill-color",attrs:{"cx":"60","cy":"60","r":"60","fill":"#80A53F"}}),_c('g',{attrs:{"filter":"url(#filter0_d_421_288)"}},[_c('path',{attrs:{"d":"M62.638 93.9a8.26 8.26 0 01-1.57-.876c-9.39-6.495-16.744-15.575-21.213-26.195-4.3-10.57-5.47-22.222-3.37-33.547a8.521 8.521 0 011.822-3.817 8.38 8.38 0 013.42-2.45l9.304-3.712a3.56 3.56 0 011.48-.239c.503.027.993.161 1.438.394.457.252.853.603 1.16 1.029.307.425.517.916.615 1.436l3.028 15.882a2.964 2.964 0 01-1.521 3.12l-6.25 3.312a34.544 34.544 0 002.717 12.786 34.374 34.374 0 007.117 11.072l6.865-2.007a2.882 2.882 0 013.149 1.083l8.998 13.422c.318.44.532.947.628 1.486a3.72 3.72 0 01-.843 3.063 3.661 3.661 0 01-1.302.965l-9.147 3.799a8.456 8.456 0 01-3.273.658 8.317 8.317 0 01-3.252-.665z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_421_288","x":"33.468","y":"23.059","width":"49.043","height":"75.504","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_421_288"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_421_288","result":"shape"}})])])])
          )
        }
      }
    